import React, { useLayoutEffect, useRef } from 'react';

/**
 * UN CHAMP DE TEXTE QUI GRANDIT AVEC CE QU'ON Y ÉCRIT.
 *
 * Vécu 28.09 : « le champ CR d'entretien est trop petit ». Trois lignes pour
 * un compte rendu d'entretien : on écrit à l'aveugle, on fait défiler un
 * timbre-poste. Le champ part d'une hauteur confortable (`minLignes`) et
 * suit le texte jusqu'à `maxHauteur` ; au-delà il défile, et la poignée de
 * redimensionnement reste là pour qui veut plus. Aucune apparence imposée :
 * la classe et le style de l'écran appelant font foi.
 */
export default function ChampExtensible({ value, minLignes = 6, maxHauteur = '60vh', style, ...reste }) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight + 2}px`;
  }, [value]);

  return (
    <textarea ref={ref} value={value} rows={minLignes}
      style={{ resize: 'vertical', overflowY: 'auto', maxHeight: maxHauteur, ...style }}
      {...reste} />
  );
}
